import { Box, Grid } from '@material-ui/core';
import CodeInput from 'components/CodeInput';
import { LongBody } from 'components/Typography';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import messages from 'containers/SignupPages/AuthByContractEpargnSms/messages';
import { FormikProps, withFormik } from 'formik';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

const InnerForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    errors,
    handleSubmit,
    isLoading,
    onClickPrevious,
    setFieldValue,
  } = props;

  const handlePinChange = (value: string) => {
    setFieldValue('pin', value);
  };
  return (
    <form onSubmit={handleSubmit}>
      <Box mb={3} paddingX={[4, 8, 12]}>
        <Grid container justify="center">
          <Grid xs={12} style={{ textAlign: 'center' }} item dir="ltr">
            <CodeInput
              name="pin"
              handleChange={handlePinChange}
              value={values.pin}
              isValid={!errors.pin}
              fields={4}
              width="56px"
            />
          </Grid>
          <Grid item xs={4}>
            {errors.pin && (
              <Box marginTop={1} marginLeft={3} marginBottom={4}>
                <LongBody color="#f5523c">
                  {translate({ ...messages.validationErrorMessage }, props)}
                </LongBody>
              </Box>
            )}
          </Grid>
          {/* <Grid item xs={matches ? 12 : 4} style={{ textAlign: 'right' }}>
            <Box marginRight={5} marginTop={1} marginBottom={4}>
              <LongBody weight="500">
                {translate({ ...messages.notYetReceived }, props)}
              </LongBody>
            </Box>
          </Grid> */}
        </Grid>
      </Box>
      <ActionsButtons onClickPrevious={onClickPrevious} isLoading={isLoading} />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: boolean;
  onClickPrevious: Function;
  onSubmitStep: Function;
}

interface FormValues {
  pin: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      pin: '',
    };
  },

  handleSubmit: (values, { props, setFieldError }) => {
    if (values.pin.length !== 4) {
      return setFieldError('pin', 'error');
    }

    return props.onSubmitStep(values);
  },
})(InnerForm);

export default injectIntl(Form);
